<section class="login">
  <div class="login-card">
    <div class="login-logo" aria-label="Tradingtagebuch">
      <span class="login-logo__rk">RK</span>
      <span class="login-logo__text">Trading</span>
    </div>
    <p class="login-subtitle">
      Erfasse deine Trades, Kommentare und Screenshots. Die Links öffnen sich in einem neuen Tab. Steuere Verlustschwelle, Basis-Risiko und stufenbasierte Erhöhung.
    </p>
    <form [formGroup]="form" (ngSubmit)="submit()" class="login-form">
      <label>
        Benutzername
        <input type="text" formControlName="username" />
      </label>
      <label>
        Kennwort
        <div class="password-field">
          <input [type]="showPassword ? 'text' : 'password'" formControlName="password" />
          <button
            type="button"
            class="password-toggle"
            (click)="togglePassword()"
            [attr.aria-pressed]="showPassword"
            [attr.aria-label]="showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M12 5c5.05 0 9.27 3.06 11 7-1.73 3.94-5.95 7-11 7S2.73 15.94 1 12c1.73-3.94 5.95-7 11-7zm0 2C8.1 7 4.77 9.16 3.12 12 4.77 14.84 8.1 17 12 17s7.23-2.16 8.88-5C19.23 9.16 15.9 7 12 7zm0 2.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm0 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
              />
            </svg>
          </button>
        </div>
      </label>
      <div class="login-error" *ngIf="errorMessage">{{ errorMessage }}</div>
      <button type="submit" class="primary" [disabled]="form.invalid">Login</button>
    </form>
  </div>
</section>
